import { render, staticRenderFns } from "./GestionFirmas.vue?vue&type=template&id=461519e6&scoped=true"
import script from "./GestionFirmas.vue?vue&type=script&lang=js"
export * from "./GestionFirmas.vue?vue&type=script&lang=js"
import style0 from "./GestionFirmas.vue?vue&type=style&index=0&id=461519e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461519e6",
  null
  
)

export default component.exports